var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.00098,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 8,
    width: 17,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.001 24C24.4193 24 28.001 20.4183 28.001 16C28.001 15.4116 27.9375 14.838 27.8169 14.2857H20.001V17.6H24.4064C23.7525 19.4 22.0269 20.6857 20.001 20.6857C17.4131 20.6857 15.3153 18.5878 15.3153 16C15.3153 13.4122 17.4131 11.3143 20.001 11.3143C21.3201 11.3143 22.5118 11.8593 23.3634 12.7365L25.6955 10.3811C24.2449 8.91109 22.2294 8 20.001 8C15.5827 8 12.001 11.5817 12.001 16C12.001 20.4183 15.5827 24 20.001 24Z",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8584 16.0312L12.0013 11.6593L17.7155 16.1164L12.0013 20.345L6.8584 16.0312Z",
    fill: "#FEBD01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 11.6602L18.4581 5.20301L25.4295 7.7173L28.4581 13.0887L19.8295 13.4316L17.7153 16.1173L12.001 11.6602Z",
    fill: "#FF4131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6582 13.9434L28.9153 13.7148L28.8011 17.8291L26.5153 22.7434L21.8296 19.0863L19.6582 18.0577V13.9434Z",
    fill: "#0286F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 20.3458L17.7153 16.1172L18.3438 18.9743L21.8295 19.0886L26.5153 22.7458L21.7724 24.8029L15.8867 24.46L12.001 20.3458Z",
    fill: "#01A94D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.000976562,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.160784 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGm);
export default __webpack_public_path__ + "static/media/gm.43b967dab658c3d5da8a15c21207134d.svg";
export { ForwardRef as ReactComponent };